module.exports = __webpack_public_path__ + "static/assets/4448bc1cafcd952b2372718dbf23ff7a.png";